import styled from 'styled-components';

export const StyledFirstStep = styled.div`
  .fs-wrapper {
    > h3 {
      font-weight: 400;
      font-size: 14px;
      line-height: 21px;
      color: var(--color-charcoal-black);
      margin-bottom: 20px;
    }

    &-box {
      display: flex;
      flex-direction: column;
      gap: 20px;

      > div {
        width: 100%;
        margin-bottom: 0;
        height: 100%;

        input[type='number']::-webkit-outer-spin-button,
        input[type='number']::-webkit-inner-spin-button {
          -webkit-appearance: none;
          margin: 0;
        }

        /* Firefox */
        input[type='number'] {
          -moz-appearance: textfield;
        }
      }
    }
  }
`;
